import { useEffect } from 'react';

import { getSyncEngine } from './engine';

/** Sets data-cs-sync-status on document.body for Playwright smoke tests. */
export function SyncStatusBodyAttributes() {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    const engine = getSyncEngine();
    const apply = () => {
      document.body.dataset.csSyncStatus = engine.getStatus();
    };
    apply();
    const unsub = engine.subscribe(apply);
    return unsub;
  }, []);
  return null;
}
